import { Link } from "react-router-dom";
import { ABOUT_IMAGE } from "@/constants/site";

const bullets = [
  "Live Project Implementation & Production Deployments",
  "Comprehensive Placement Network with Hiring Partners",
  "End-to-End Enterprise Software & Cloud Architectures",
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="py-24 md:py-32 bg-[#101b33] text-[#dce7f9] border-b border-[#203154]">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-6 min-w-0">
              <figure
                className="relative aspect-[4/3] rounded-xl bg-[#0c1427] border border-[#203154] overflow-hidden flex items-end"
                data-testid="about-image-figure"
              >
                <img
                  src={ABOUT_IMAGE}
                  alt="Students learning in an Adipurusa Infotech classroom with laptops"
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0c1427] via-[#0c1427]/40 to-transparent" />
                <figcaption className="relative z-10 text-xs font-mono uppercase tracking-wider text-[#38bdf8] p-6">
                  Adipurusa Innovation &amp; Learning Center
                </figcaption>
              </figure>
            </div>
            <div className="lg:col-span-6 min-w-0">
              <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-3">
                Company Overview
              </div>
              <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-6">
                Empowering Ambition with Engineering Rigor
              </h1>
              <p className="text-sm text-[#9cb4d8] leading-relaxed mb-6">
                Adipurusa Infotech Private Limited operates at the convergence of technology
                education and real-world engineering. We combine industry-veteran trainers with a
                high-capacity software development studio — delivering job-oriented programs across
                India and online, and enterprise-grade delivery for clients anywhere.
              </p>
              <div className="space-y-3 font-mono text-xs text-[#9cb4d8]">
                {bullets.map((b) => (
                  <div key={b} className="flex items-center gap-3">
                    <span className="w-2 h-2 rounded bg-[#38bdf8]" />
                    <span>{b}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="py-24 md:py-32 bg-[#0c1427] border-b border-[#203154]" data-testid="about-why-section">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center max-w-2xl mx-auto mb-16">
            <div className="text-xs font-mono uppercase tracking-widest text-[#38bdf8] mb-3">
              Why Adipurusa
            </div>
            <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white">
              Built on Delivery, Not Promises
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                t: "Industry-Expert Trainers",
                d: "Programs are taught by working enterprise professionals, with hands-on projects on live stacks.",
              },
              {
                t: "Strong Placement Record",
                d: "A hiring-partner network, mock interviews, and recruiter pipelines behind every graduate.",
              },
              {
                t: "Affordable & Job-Oriented",
                d: "Programs priced for accessibility and structured around what employers actually test for.",
              },
              {
                t: "Trusted Delivery Partner",
                d: "Enterprises rely on us for product engineering, cloud, ERP, and staff augmentation.",
              },
            ].map((c, i) => (
              <div
                key={c.t}
                className="p-8 rounded-xl bg-[#162544] border border-[#203154]"
                data-testid={`why-card-${i + 1}`}
              >
                <div className="text-2xl font-bold font-mono text-[#38bdf8] mb-4">
                  0{i + 1}
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{c.t}</h3>
                <p className="text-xs text-[#9cb4d8] leading-relaxed">{c.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-[#0c1427]" data-testid="about-cta-section">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="font-heavy text-[clamp(32px,4.5vw,64px)] uppercase text-white leading-[0.95] tracking-tight mb-8">
            <span className="ln"><span>Ready to</span></span>
            <span className="ln"><span className="text-[#38bdf8]">Get Started?</span></span>
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/courses"
              data-testid="about-cta-courses"
              className="py-3 px-8 rounded bg-[#38bdf8] text-[#0c1427] text-xs font-bold font-mono uppercase tracking-wider hover:bg-white transition-colors"
            >
              Explore Courses →
            </Link>
            <Link
              to="/services#contact"
              data-testid="about-cta-contact"
              className="py-3 px-8 rounded bg-[#203154] text-white text-xs font-bold font-mono uppercase tracking-wider hover:bg-[#38bdf8] hover:text-[#0c1427] transition-colors"
            >
              Contact Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
